import { useMemo, useState } from 'react';
const DEFAULT_ITEMS_PER_PAGE = 20;
export function usePagination({
  items,
  itemsPerPage = DEFAULT_ITEMS_PER_PAGE,
  initialPage = 1
}) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const paginatedItems = useMemo(() => {
    const offset = (currentPage - 1) * itemsPerPage;
    return items.slice(offset, offset + itemsPerPage);
  }, [items, currentPage, itemsPerPage]);
  const pageCount = Math.ceil(items.length / itemsPerPage);
  const needsPagination = pageCount > 1;
  const handlePageChange = ({
    target: {
      value
    }
  }) => {
    setCurrentPage(value);
  };
  return {
    currentPage,
    setCurrentPage,
    paginatedItems,
    pageCount,
    needsPagination,
    handlePageChange
  };
}